module.exports = __webpack_public_path__ + "static/media/hands.0b2082a2.svg";